module.exports = __webpack_public_path__ + "media/application/images/logo_v2-73badd4eb9e8e4bc3b15d029e2d6a1a4.png";